// Utility to detect crawlers and bypass consent requirements
export const isCrawler = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Common crawler user agents
  const crawlerPatterns = [
    'googlebot',
    'bingbot', 
    'slurp',
    'duckduckbot',
    'baiduspider',
    'yandexbot',
    'facebookexternalhit',
    'twitterbot',
    'linkedinbot',
    'whatsapp',
    'telegrambot',
    'discordbot',
    'slackbot',
    'applebot',
    'ia_archiver',
    'archive.org_bot',
    'ahrefsbot',
    'semrushbot',
    'mj12bot',
    'dotbot',
    'rogerbot',
    'screaming_frog',
    'lighthouse',
    'pagespeed',
    'gtmetrix',
    'webpagetest'
  ];
  
  return crawlerPatterns.some(pattern => userAgent.includes(pattern));
};

// Check if this is a headless browser (common for crawlers)
export const isHeadlessBrowser = () => {
  return (
    !navigator.webdriver === false || // Chrome headless
    navigator.userAgent.includes('HeadlessChrome') ||
    navigator.userAgent.includes('PhantomJS') ||
    navigator.userAgent.includes('Selenium') ||
    navigator.userAgent.includes('Puppeteer')
  );
};

// Check if this is likely a crawler
export const shouldBypassConsent = () => {
  return isCrawler() || isHeadlessBrowser();
};

// Set appropriate consent state for crawlers
export const setCrawlerConsent = () => {
  if (shouldBypassConsent()) {
    // Import here to avoid circular dependencies
    const { grantCrawlerConsent } = require('./consentManager');
    grantCrawlerConsent();
    return true;
  }
  return false;
};